import { render, staticRenderFns } from "./CardMercadoPago.vue?vue&type=template&id=647f9605&"
import script from "./CardMercadoPago.vue?vue&type=script&lang=js&"
export * from "./CardMercadoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports